import React from 'react'
import styled from 'styled-components'
import Button from '@material-ui/core/Button'
import SlidersH from '../icons/SlidersH'
import PlusCircle from '../icons/PlusCircle'
import styledTheme from '../../styles/theme'

const Container = styled.div`
  border-bottom: 1px solid #CCC;
  width: 100%;
  padding: 0.6rem;
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  z-index: 10;
`

const CustomButton = styled(Button)`
  && {
    font-size: 0.75rem;
    padding: 8px 8px;
    min-height: unset;
  }
`

const ActionButton = styled.div`
  display: inline-flex;
  margin-right: 0.6rem;
  &:hover {
    cursor: pointer;
  }
  svg {
    height: 0.75rem;
    width: 0.75rem;
    path {
    }
  }
`

export default class GraphActionsBar extends React.Component {

  renderBody = (props,state) => <Container visible={props.visible}>
    <CustomButton variant="outlined" onClick={props.manualInputFormOpenHandler}>
      <ActionButton><PlusCircle /></ActionButton>
      Add Manual Input
    </CustomButton>
  </Container>

  render = () => this.renderBody(this.props,this.state)

}




// WEBPACK FOOTER //
// ./src/components/dataViews/GraphActionsBar.js